import React, { useContext, useEffect, useRef, useState } from "react";
import {
  FaSearch,
  FaPhoneAlt,
  FaChevronDown,
  FaChevronUp,
  FaBars,
} from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import OrderWithCartsPopup from "../OrderPopUp/OrderWithCartsPopup";
// import Logo from "../Assets/logo-02.jpeg";
import Logo from "../Assets/fabhub-logo-nav.png";
import { ShopContext } from "../../Context/ShopContext";
import { WishlistContext } from "../../Context/WishlistContext";
import { MdOutlineShoppingCart, MdClose, MdDelete } from "react-icons/md";
import { IoIosArrowDown } from "react-icons/io";
import { LuUserRound } from "react-icons/lu";
import { FaHeart } from "react-icons/fa";
import { FiHeart } from "react-icons/fi";
import "react-toastify/dist/ReactToastify.css";
import { currency, backend_url } from "../../App";
import Dropdown from "../Navbar/DropDown";
import { toast } from "react-toastify";

import { menuItems } from "../../Constants/menuItems";

const Search = ({ setSearchResults }) => {
  const {
    products,
    addToCart,
    cartItems,
    removeFromCart,
    getTotalCartItems,
    deleteFromCart,
    getTotalCartAmount,
  } = useContext(ShopContext);

  const { wishlist, setWishlistOpen } = useContext(WishlistContext);
  const [open, setOpen] = useState(false);
  // const [toggleOpen, settoggleOpen] = useState(false);
  const [isDesktopDropdownOpen, setIsDesktopDropdownOpen] = useState(false);
  const [isMobileDropdownOpen, setIsMobileDropdownOpen] = useState(false);
  const location = useLocation();
  const [orderPopupOpen, setOrderPopupOpen] = useState(false);
  const dropdownRef = useRef(null);
  const mobileDropdownRef = useRef(null);

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const cartRef = useRef(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const forceUpdate = useState()[1];
  const isAuthorize = !!localStorage.getItem("auth-token");
  const [openMenu, setOpenMenu] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openMobileDropdown, setOpenMobileDropdown] = useState(null);
  const [openSubDropdowns, setOpenSubDropdowns] = useState({});
  const [announcement, setAnnouncement] = useState(null);

  useEffect(() => {
    fetch(`${backend_url}/api/settings`)
      .then((r) => r.json())
      .then((d) => {
        if (d.success && d.settings?.announcementEnabled && d.settings?.announcementText?.trim()) {
          setAnnouncement(d.settings.announcementText.trim());
        }
      })
      .catch(() => {});
  }, []);

  const toggleSubDropdown = (parentIndex, subIndex) => {
    setOpenSubDropdowns((prev) => ({
      ...prev,
      [parentIndex]: {
        ...prev[parentIndex],
        [subIndex]: !prev[parentIndex]?.[subIndex],
      },
    }));
  };

  const toggleMobileMenu = () => setIsMobileMenuOpen((prev) => !prev);
  const toggleMobileDropdown = (index) => {
    setOpenMobileDropdown((prev) => (prev === index ? null : index));
  };

  const handleItemClick = (item) => {
    if (!item.dropdown && !item.subDropdown) {
      handleMouseLeave();
    }
  };

  const handleMouseEnter = (index) => setOpenMenu(index);
  const handleMouseLeave = () => setOpenMenu(null);
  const [showPopup, setShowPopup] = useState(false);

  const handlePopupNow = () => {
    if (!isAuthorize) {
      toast.info("Please Login/Register to continue with your order");
      return;
    }
    setShowPopup(true);
  };

  const closePopup = () => setShowPopup(false);
  // Filter products based on search input
  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowResults(false);
        setIsDesktopDropdownOpen(false);
      }
      if (
        mobileDropdownRef.current &&
        !mobileDropdownRef.current.contains(event.target)
      ) {
        setIsMobileDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Handle search logic
  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query.trim() !== "") {
      const filtered = products.filter((product) =>
        product.name.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredProducts(filtered);
      setSearchResults(filtered);
    } else {
      setFilteredProducts([]);
      setSearchResults([]);
    }
  };

  const handleCategorySelect = (category, source) => {
    if (source === "mobile") {
      setIsMobileDropdownOpen(false);
    } else {
      setIsDesktopDropdownOpen(false);
    }
    setSelectedCategory(category);

    let baseList = [...products];
    let filteredCategory = [];

    if (category === "Best-Sellers") {
      filteredCategory = baseList.filter(
        (product) => product.bestseller?.toLowerCase() === "yes"
      );
      if (filteredCategory.length === 0) {
        toast.error("No best sellers available right now");
      }
    } else {
      filteredCategory = baseList.filter(
        (product) => product.category?.toLowerCase() === category.toLowerCase()
      );
      if (filteredCategory.length === 0) {
        toast.error(`No products found in "${category}"`);
      }
    }
    setIsMobileDropdownOpen(false);

    // Apply search filter
    if (searchQuery.trim() !== "") {
      const filtered = filteredCategory.filter((product) =>
        product.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredProducts(filtered);
      setSearchResults(filtered);
    } else {
      setFilteredProducts(filteredCategory);
      setSearchResults(filteredCategory);
    }
  };

  return (
    <>
      <div className="">
        {/* Running Announcement Section (managed from Admin → Settings) */}
        {announcement && (
          <div
            className="w-full py-2 font-semibold text-xs sm:text-sm flex items-center overflow-hidden"
            style={{ background: "linear-gradient(90deg, #8353C6, #9E79D2, #8353C6)" }}
          >
            <div className="whitespace-nowrap overflow-hidden flex-grow">
              <p className="inline-block animate-marquee text-white tracking-wide uppercase">
                {announcement}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{announcement}
              </p>
            </div>
          </div>
        )}

        <nav className="w-full bg-white relative z-50 px-4 md:px-8 py-2 border-b border-purple-100 shadow-[0_2px_16px_rgba(124,58,237,0.07)]">
          {/* Top Row - Desktop */}
          <div className="hidden md:flex items-center justify-between gap-6">
            {/* Logo */}
            <div className="flex-shrink-0">
              <Link to="/">
                <img crossOrigin="anonymous" src={Logo} alt="Logo" className="w-[110px]" />
              </Link>
            </div>

            {/* Search */}
            <div className="flex-1 flex justify-center">
              <div className="relative flex items-center rounded-full w-full max-w-2xl shadow-sm focus-within:shadow-[0_0_0_2px_#9E79D2] transition-all" style={{ border: "1.5px solid #D6C3F0" }}>
                <div className="relative" ref={dropdownRef}>
                  <button
                    className="text-white text-sm px-4 py-2.5 flex items-center gap-2 rounded-l-full font-semibold"
                    style={{ background: "linear-gradient(90deg, #8353C6, #9E79D2)" }}
                    onClick={() => setIsDesktopDropdownOpen(!isDesktopDropdownOpen)}
                  >
                    <span className="truncate max-w-[120px]">{selectedCategory || "Best-Sellers"}</span>
                    <IoIosArrowDown className={`transition-transform ${isDesktopDropdownOpen ? "rotate-180" : ""}`} />
                  </button>
                  {isDesktopDropdownOpen && (
                    <div onMouseLeave={() => setIsDesktopDropdownOpen(false)}
                      className="absolute top-full left-0 bg-white shadow-xl border border-purple-100 rounded-2xl mt-2 z-50 min-w-max overflow-hidden py-1">
                      {["Best-Sellers","Fabrics","Sarees","Customized Fabrics","Aavriyaa's Exclusive","Vintage Collection"].map((option, index) => (
                        <p key={index} onClick={() => handleCategorySelect(option)}
                          className="px-5 py-2.5 text-sm text-gray-700 hover:bg-purple-50 hover:text-purple-700 cursor-pointer whitespace-nowrap font-medium transition-colors">
                          {option}
                        </p>
                      ))}
                    </div>
                  )}
                </div>
                <FaSearch className="text-purple-400 cursor-pointer mx-3 flex-shrink-0" />
                <input type="text" placeholder="Search fabrics, sarees & more…" onChange={handleSearch}
                  className="text-sm w-full pr-4 py-2.5 outline-none text-gray-700 placeholder-gray-400 bg-transparent rounded-r-full" />
              </div>
            </div>

            {/* Icons */}
            <div className="flex items-center gap-3 flex-shrink-0">
              <a href="tel:+919944592904"
                className="w-9 h-9 rounded-full flex items-center justify-center bg-purple-50 hover:bg-purple-600 group transition-all duration-200 border border-purple-100">
                <FaPhoneAlt className="text-sm text-purple-600 group-hover:text-white transition-colors" />
              </a>
              <Link to="/user-profile"
                className="w-9 h-9 rounded-full flex items-center justify-center bg-purple-50 hover:bg-purple-600 group transition-all duration-200 border border-purple-100 relative">
                <LuUserRound className="text-lg text-purple-600 group-hover:text-white transition-colors" />
                <span className="absolute -top-1 -right-1 text-sm leading-none">⚡</span>
              </Link>

              {/* Wishlist heart */}
              <button
                onClick={() => setWishlistOpen(true)}
                className="w-9 h-9 rounded-full flex items-center justify-center transition-all duration-200 border relative"
                style={{
                  background: wishlist.length > 0 ? "linear-gradient(135deg,#8353C6,#9E79D2)" : "#F6F1FE",
                  borderColor: wishlist.length > 0 ? "transparent" : "#EEE5FA",
                }}
                title="My Wishlist"
              >
                {wishlist.length > 0
                  ? <FaHeart size={14} color="white" />
                  : <FiHeart size={14} style={{ color: "#8353C6" }} />
                }
                {wishlist.length > 0 && (
                  <span className="absolute -top-1.5 -right-1.5 bg-pink-500 text-white text-[10px] font-bold w-5 h-5 rounded-full flex items-center justify-center">
                    {wishlist.length}
                  </span>
                )}
              </button>

              <button onClick={() => setOpen(true)}
                className="w-9 h-9 rounded-full flex items-center justify-center bg-purple-50 hover:bg-purple-600 group transition-all duration-200 border border-purple-100 relative">
                <MdOutlineShoppingCart className="text-xl text-purple-600 group-hover:text-white transition-colors" />
                {getTotalCartItems() > 0 && (
                  <span className="absolute -top-1.5 -right-1.5 bg-green-500 text-white text-[10px] font-bold w-5 h-5 rounded-full flex items-center justify-center">
                    {getTotalCartItems()}
                  </span>
                )}
              </button>
            </div>
          </div>

          {/* Top Row - Mobile */}
          <div className="flex md:hidden items-center justify-between py-1">
            <Link to="/"><img crossOrigin="anonymous" src={Logo} alt="Logo" className="w-[100px]" /></Link>
            <div className="flex items-center gap-2">
              <a href="tel:+919944592904"
                className="w-8 h-8 rounded-full flex items-center justify-center bg-purple-50 border border-purple-100">
                <FaPhoneAlt className="text-xs text-purple-600" />
              </a>
              <Link to="/user-profile"
                className="w-8 h-8 rounded-full flex items-center justify-center bg-purple-50 border border-purple-100 relative">
                <LuUserRound className="text-base text-purple-600" />
                <span className="absolute -top-1 -right-1 text-xs leading-none">⚡</span>
              </Link>
              {/* Wishlist heart - mobile */}
              <button
                onClick={() => setWishlistOpen(true)}
                className="w-8 h-8 rounded-full flex items-center justify-center border relative"
                style={{
                  background: wishlist.length > 0 ? "linear-gradient(135deg,#8353C6,#9E79D2)" : "#F6F1FE",
                  borderColor: wishlist.length > 0 ? "transparent" : "#EEE5FA",
                }}
              >
                {wishlist.length > 0
                  ? <FaHeart size={12} color="white" />
                  : <FiHeart size={12} style={{ color: "#8353C6" }} />
                }
                {wishlist.length > 0 && (
                  <span className="absolute -top-1 -right-1 bg-pink-500 text-white text-[9px] font-bold w-4 h-4 rounded-full flex items-center justify-center">
                    {wishlist.length}
                  </span>
                )}
              </button>

              <button onClick={() => setOpen(true)}
                className="w-8 h-8 rounded-full flex items-center justify-center bg-purple-50 border border-purple-100 relative">
                <MdOutlineShoppingCart className="text-lg text-purple-600" />
                {getTotalCartItems() > 0 && (
                  <span className="absolute -top-1 -right-1 bg-green-500 text-white text-[9px] font-bold w-4 h-4 rounded-full flex items-center justify-center">
                    {getTotalCartItems()}
                  </span>
                )}
              </button>
              <button onClick={toggleMobileMenu}
                className="w-8 h-8 rounded-full flex items-center justify-center bg-purple-50 border border-purple-100">
                <FaBars className="text-base text-purple-600" />
              </button>
            </div>
          </div>

          {/* Search - Mobile */}
          <div className="mt-2 md:hidden">
            <div className="relative flex items-center rounded-full w-full" style={{ border: "1.5px solid #D6C3F0" }}>
              <div className="relative" ref={mobileDropdownRef}>
                <button
                  className="text-white text-xs px-3 py-2 flex items-center gap-1 rounded-l-full font-semibold"
                  style={{ background: "linear-gradient(90deg, #8353C6, #9E79D2)" }}
                  onClick={() => setIsMobileDropdownOpen(!isMobileDropdownOpen)}
                >
                  <span className="truncate max-w-[90px]">{selectedCategory || "Best-Sellers"}</span>
                  <IoIosArrowDown className="text-xs" />
                </button>
                {isMobileDropdownOpen && (
                  <div className="absolute top-full left-0 bg-white shadow-xl border border-purple-100 rounded-2xl mt-2 z-50 min-w-max overflow-hidden py-1">
                    {["Best-Sellers","Fabrics","Sarees","Customized Fabrics","Aavriyaa's Exclusive","Vintage Collection"].map((option, index) => (
                      <p key={index} onClick={() => handleCategorySelect(option)}
                        className="px-4 py-2 text-sm text-gray-700 hover:bg-purple-50 hover:text-purple-700 cursor-pointer font-medium">
                        {option}
                      </p>
                    ))}
                  </div>
                )}
              </div>
              <FaSearch className="text-purple-400 mx-2 text-sm flex-shrink-0" />
              <input type="text" placeholder="Search…" onChange={handleSearch}
                className="text-sm w-full pr-3 py-2 outline-none text-gray-700 bg-transparent rounded-r-full" />
            </div>
          </div>

          {/* Desktop nav menu */}
          <div className="hidden md:flex justify-center mt-2.5 mb-1 border-t border-purple-50 pt-2.5">
            <ul className="flex gap-1">
              {menuItems.map((item, index) => (
                <li key={index} className="relative group overflow-visible"
                  onMouseEnter={() => handleMouseEnter(index)}
                  onMouseLeave={handleMouseLeave}>
                  {item.path ? (
                    <Link to={item.path}
                      className="relative flex items-center gap-1 px-4 py-1.5 rounded-full text-sm font-semibold text-gray-600
                                 hover:text-purple-700 hover:bg-purple-50 transition-all duration-200 tracking-wide">
                      {item.label}
                      {/* Active underline dot */}
                      <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-purple-500 opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
                    </Link>
                  ) : (
                    // Dropdown-only item: no navigation, click also toggles (for touch devices)
                    <button
                      type="button"
                      onClick={() => setOpenMenu(openMenu === index ? null : index)}
                      className="relative flex items-center gap-1 px-4 py-1.5 rounded-full text-sm font-semibold text-gray-600
                                 hover:text-purple-700 hover:bg-purple-50 transition-all duration-200 tracking-wide">
                      {item.label}
                      {item.dropdown && (
                        <IoIosArrowDown className={`text-xs transition-transform duration-200 ${openMenu === index ? "rotate-180 text-purple-600" : ""}`} />
                      )}
                      <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-purple-500 opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
                    </button>
                  )}
                  {item.dropdown && openMenu === index && <Dropdown items={item.dropdown} />}
                </li>
              ))}
            </ul>
          </div>
        </nav>

        {/* Off-Canvas Mobile Menu */}
        {isMobileMenuOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-40 z-40"
            onClick={() => setIsMobileMenuOpen(false)}
          />
        )}
        <div
          className={`fixed top-0 right-0 h-full w-72 bg-white shadow-lg z-50 transform transition-transform duration-300 ease-in-out ${
            isMobileMenuOpen ? "translate-x-0" : "translate-x-full"
          }`}
        >
          {/* Sidebar header */}
          <div className="flex justify-between items-center px-5 py-4"
               style={{ background: "linear-gradient(135deg, #3A2060, #8353C6)" }}>
            <div>
              <p className="text-white font-bold text-base">AavryaA FabHub</p>
              <p className="text-purple-200 text-xs">Premium Indian Fabrics</p>
            </div>
            <button onClick={() => setIsMobileMenuOpen(false)}
              className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center hover:bg-white/30 transition">
              <MdClose className="text-white text-lg" />
            </button>
          </div>

          {/* Menu Items */}
          <ul className="flex flex-col gap-2 px-4 py-3 pb-24 text-gray-800 text-sm overflow-y-auto h-full">
            {menuItems.map((item, index) => (
              <li key={index}>
                <div
                  className="flex justify-between items-center cursor-pointer py-2"
                  onClick={() =>
                    item.dropdown
                      ? toggleMobileDropdown(index)
                      : setIsMobileMenuOpen(false)
                  }
                >
                  <Link
                    to={item.path || "#"}
                    className="block hover:text-purple-600"
                    onClick={() => !item.dropdown && setIsMobileMenuOpen(false)}
                  >
                    {item.label}
                  </Link>
                  {item.dropdown && (
                    <span>
                      {openMobileDropdown === index ? (
                        <FaChevronUp className="text-xs" />
                      ) : (
                        <FaChevronDown className="text-xs" />
                      )}
                    </span>
                  )}
                </div>
                {item.dropdown && openMobileDropdown === index && (
                  <ul className="pl-4 border-l border-purple-300 ml-2">
                    {item.dropdown.map((subItem, subIndex) => (
                      <li key={subIndex} className="py-1">
                        {subItem.subDropdown ? (
                          // This is a dropdown toggle
                          <div
                            className="flex justify-between items-center cursor-pointer pl-2 pr-2"
                            onClick={() => toggleSubDropdown(index, subIndex)}
                          >
                            <span className="text-sm text-gray-800 hover:text-purple-600">
                              {subItem.label}
                            </span>
                            {openSubDropdowns?.[index]?.[subIndex] ? (
                              <FaChevronUp className="text-xs" />
                            ) : (
                              <FaChevronDown className="text-xs" />
                            )}
                          </div>
                        ) : (
                          // This is a normal link
                          <Link
                            to={subItem.path || "#"}
                            className="block hover:text-purple-600 pl-2 pr-2"
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            {subItem.label}
                          </Link>
                        )}

                        {/* Handle subDropdown */}
                        {subItem.subDropdown &&
                          openSubDropdowns?.[index]?.[subIndex] && (
                            <ul className="ml-4 border-l border-purple-200 mt-1">
                              {subItem.subDropdown.map(
                                (nested, nestedIndex) => (
                                  <li key={nestedIndex} className="py-1">
                                    <Link
                                      to={nested.path}
                                      className="block text-sm text-gray-600 hover:text-purple-600"
                                      onClick={() => setIsMobileMenuOpen(false)}
                                    >
                                      {nested.label}
                                    </Link>
                                  </li>
                                )
                              )}
                            </ul>
                          )}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>

        {/* Overlay & Cart Section */}
        {open && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-[60] transition-opacity duration-300"
            onClick={() => setOpen(false)}
          >
            <div
              ref={cartRef}
              onClick={(e) => e.stopPropagation()}
              className="cart-container fixed top-0 right-0 w-full sm:w-3/4 md:w-1/2 lg:w-1/3 xl:w-[28%] z-[70] bg-white h-screen border-l shadow-2xl flex flex-col"
            >
              {/* Header */}
              <div className="flex justify-between items-center px-5 py-4"
                   style={{ background: "linear-gradient(135deg, #3A2060, #8353C6)" }}>
                <div>
                  <p className="text-white font-bold text-lg">Your Cart</p>
                  <p className="text-purple-200 text-xs">{getTotalCartItems()} item{getTotalCartItems() !== 1 ? "s" : ""}</p>
                </div>
                <button onClick={() => setOpen(false)}
                  className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center hover:bg-white/30 transition">
                  <MdClose className="text-white text-lg" />
                </button>
              </div>

              {/* Product Section (scrollable) */}
              <div className="flex-1 overflow-y-auto">
                {Object.keys(cartItems).length > 0 ? (
                  Object.keys(cartItems)
                    .filter((id) => cartItems[id] > 0)
                    .map((id) => {
                      const product = products.find(
                        (p) => p.id === parseInt(id)
                      );
                      return product ? (
                        <div
                          key={id}
                          className="justify-center items-center p-4 border-b flex gap-4"
                        >
                          {/* Product Image */}
                          <img
                            crossOrigin="anonymous"
                            className="w-24 h-24 object-cover rounded-lg border"
                            src={product.images[0]}
                            alt={product.name}
                          />

                          {/* Product Details */}
                          <div className="flex flex-col flex-1 justify-between">
                            <p className="text-lg font-semibold break-words">
                              {product.name}
                            </p>

                            <div>
                              <p className="text-gray-500">
                                {currency}
                                {(
                                  (product.old_price *
                                    (100 - product.new_price)) /
                                  100
                                ).toFixed(2)}{" "}
                                x {cartItems[id]}{" "}
                                <span className="line-through text-red-400 ml-2">
                                  {currency}
                                  {product.old_price.toFixed(2)}
                                </span>
                              </p>
                              <p className="text-gray-700 mt-1">
                                Total: {currency}
                                {(
                                  ((product.old_price *
                                    (100 - product.new_price)) /
                                    100) *
                                  cartItems[id]
                                ).toFixed(2)}
                              </p>
                            </div>
                      
                            <div className="flex justify-between items-center mt-2">
                              <div className="flex gap-2 items-center">
                                {(() => {
                                  const step =
                                    product.scale?.toLowerCase() === "meters"
                                      ? 0.5
                                      : 1;
                                  const minVal = step;
                                  return (
                                    <div className="flex items-center border border-[#dae2e6] rounded-lg overflow-hidden">
                                      <button
                                        className="px-3 py-1 border-r border-[#dae2e6]"
                                        onClick={() =>
                                          removeFromCart(
                                            Number(product.id),
                                            step
                                          )
                                        }
                                      >
                                        -
                                      </button>
                                      <input
                                        type="number"
                                        value={cartItems[product.id]}
                                        onChange={(e) => {
                                          const newVal =
                                            parseFloat(e.target.value) ||
                                            minVal;
                                          if (newVal >= minVal) {
                                            // addToCart adds a delta, so pass the difference to set the value
                                            const delta =
                                              newVal - (cartItems[product.id] || 0);
                                            if (delta !== 0) {
                                              addToCart(Number(product.id), delta);
                                            }
                                          }
                                        }}
                                        className="w-16 text-center outline-none"
                                        step={step}
                                        min={minVal}
                                      />
                                      <button
                                        className="px-3 py-1 border-l border-[#dae2e6]"
                                        onClick={() =>
                                          addToCart(Number(product.id), step)
                                        }
                                      >
                                        +
                                      </button>
                                    </div>
                                  );
                                })()}
                              </div>

                              <button
                                className="p-1"
                                onClick={() =>
                                  deleteFromCart(Number(product.id))
                                }
                              >
                                <MdDelete className="text-lg text-red-500" />
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : null;
                    })
                ) : (
                  <div className="text-center py-12 text-xl text-gray-500">
                    Your cart is empty!
                  </div>
                )}
              </div>

              {/* Footer */}
              <div className="flex justify-between items-center px-5 py-4 border-t">
                <p className="text-lg font-semibold">
                  Total: {currency}
                  {getTotalCartAmount().toFixed(2)}
                </p>

                {Object.keys(cartItems).filter((id) => cartItems[id] > 0)
                  .length > 0 && (
                  <button
                    className="text-white px-5 py-2 rounded-full font-semibold hover:opacity-90 active:scale-95 transition-all duration-200 shadow"
                    style={{ background: "linear-gradient(90deg, #8353C6, #9E79D2)" }}
                    onClick={() => {
                      setOpen(false);
                      handlePopupNow(true);
                    }}
                  >
                    Checkout
                  </button>
                )}
              </div>
            </div>
          </div>
        )}

        <OrderWithCartsPopup
          cartItems={Object.keys(cartItems)
            .filter((id) => cartItems[id] > 0)
            .map((id) => {
              const product = products.find((p) => p.id === parseInt(id));
              if (!product) return null;

              const price =
                (product.old_price * (100 - product.new_price)) / 100;

              return {
                id: product.id,
                productId: product._id,
                name: product.name,
                quantity: cartItems[id],
                price: price,
                image: product.images?.[0] || "",
              };
            })
            .filter(Boolean)}
          currency={currency}
          showPopup={showPopup}
          closePopup={closePopup}
        />
      </div>
    </>
  );
};

export default Search;
